import { WorldCoord } from "@latticexyz/phaserx/src/types";
import { EntityIndex, EntityID, World } from "@latticexyz/recs";
import { ActionSystem } from "@latticexyz/std-client";
import { NetworkLayer } from "../../Network";

export function dropInventory(
  context: {
    network: NetworkLayer;
    actions: ActionSystem;
    world: World;
  },
  inventoryOwnerEntity: EntityIndex,
  position: WorldCoord
) {
  const {
    network: { api: networkApi },
    world,
    actions,
  } = context;

  const actionID = `drop inventory ${Date.now()}` as EntityID; // Date.now to have the actions ordered in the component browser

  actions.add({
    id: actionID,
    components: {},
    on: inventoryOwnerEntity,
    requirement: () => true,
    updates: () => [],
    execute: async () => {
      return networkApi.dropInventory(world.entities[inventoryOwnerEntity], position);
    },
  });
}
